import links from '../../constants/links'
import { LegalPageElement } from '../../contexts/panelsContext'
import { UIElement } from '../../types/UIElements'

// the museum's legal pages: linked on the web, shown as a QR code on the kiosk
const legalPages: Record<
  LegalPageElement,
  { labelKey: string; dialogTitleKey: string; link: string }
> = {
  [UIElement.LEGALNOTICE]: {
    labelKey: 'museumLegalNotice',
    dialogTitleKey: 'legalPages.legalNoticeTitle',
    link: links.MUSEUMLEGALNOTICE,
  },
  [UIElement.TERMSOFUSE]: {
    labelKey: 'museumTermsOfUse',
    dialogTitleKey: 'legalPages.termsOfUseTitle',
    link: links.MUSEUMTERMSOFUSE,
  },
}

export default legalPages
